// extracted by mini-css-extract-plugin
export var avatarContainer = "_fe-0";
export var gray = "_fe-f";
export var green = "_fe-c";
export var icon = "_fe-9";
export var image = "_fe-1";
export var lg = "_fe-6";
export var md = "_fe-5";
export var presenceDot = "_fe-b";
export var red = "_fe-d";
export var sm = "_fe-4";
export var status = "_fe-a";
export var xl = "_fe-7";
export var xs = "_fe-3";
export var xxl = "_fe-8";
export var xxs = "_fe-2";
export var yellow = "_fe-e";